var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9571 19.2071C16.3476 18.8166 16.3476 18.1834 15.9571 17.7929L10.1642 12L15.9571 6.20711C16.3476 5.81658 16.3476 5.18342 15.9571 4.79289C15.5666 4.40237 14.9334 4.40237 14.5429 4.79289L8.75 10.5858C7.96895 11.3668 7.96895 12.6332 8.75 13.4142L14.5429 19.2071C14.9334 19.5976 15.5666 19.5976 15.9571 19.2071Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleft);
export default __webpack_public_path__ + "static/media/chevronleft.054fab28cc970b0675f38c80d708cb28.svg";
export { ForwardRef as ReactComponent };